import './website.css';
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';

// import pages
import Home from './pages/home/home.js';
import Portfolio from './pages/portfolio/portfolio.js';
import Contact from './pages/contact/contact.js'
import SignIn from './pages/signIn/signIn.js';
import SignUp from './pages/signUp/signUp.js';

// import assets
import ExpensibleLogo from '../assets/expensibleLogo/expensibleLogo.js';

// import footer
import Footer from './footer/footer.js';

export default function Website(){

    const mobileBreakPoint = window.innerWidth;
    const [mobileApp, SetMobileApp] = useState(false);

    useEffect(() => {
        isMobile(mobileBreakPoint);
    }, []);

    const isMobile = (mobileBreakPoint) => {
        if (mobileBreakPoint < 640) {
            SetMobileApp(true);
        } else {
            SetMobileApp(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        if (mobileApp === true) {
            setActiveNav(prev => !prev);
        }
    };

    const [loginKey, setLoginKey] = useState(false);

    const [activeNav, setActiveNav] = useState(false);

    const hamburgerMenu = () => {
        setActiveNav(prev => !prev); 
    };
    
    return(
        <div>
            <div>
                <BrowserRouter>
                <div className="nav-bar-header">
                    <div className={activeNav ? 'nav-bar-active' : 'nav-bar-container'}>
                        {activeNav ? '' : <NavLink to="/"><ExpensibleLogo to="/"/></NavLink>}
                        <nav className="nav-bar">
                            <NavLink to="/"><a onClick={scrollToTop}>Home</a></NavLink>
                            <NavLink to="/portfolio"><a onClick={scrollToTop}>Portfolio</a></NavLink>
                            <NavLink to="/contact"><a onClick={scrollToTop}>Contact</a></NavLink>
                            <NavLink to="/sign_in"><a onClick={scrollToTop}>Sign In</a></NavLink>
                            <NavLink to="/sign_up"><a className="nav-button" onClick={scrollToTop}>Sign Up</a></NavLink>
                        </nav>
                        {activeNav ? <NavLink to="/"><ExpensibleLogo to="/"/></NavLink> : ''}
                        <div className={activeNav ? 'hamburger-nav-active' : 'hamburger-nav'} onClick={hamburgerMenu}></div>
                    </div>
                </div>
                <Routes>
                    <Route path="/" element={<Home isMobile={mobileApp} />} />
                    <Route path="/portfolio" element={<Portfolio isMobile={mobileApp}/>} />
                    <Route path="/contact" element={<Contact isMobile={mobileApp} />} />
                    <Route path="/sign_in" element={<SignIn onSignInSuccess={setLoginKey} />} />
                    <Route path="/sign_up" element={<SignUp />} />
                </Routes>
                
                <Footer isMobile={mobileApp} scrollNavigation={scrollToTop}/>
                </BrowserRouter>
                
            </div>
            
        </div>
    )
};